import React from 'react';
import { Link } from 'react-router-dom';
import Text from './Text.js';
import { colors } from '../theme/index.js';

/**
 * 
 * @param {*} param0 
 */
const Subtitle = ({
  title,
  link,
  id,
  testid
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  }
}, /*#__PURE__*/React.createElement(Text, {
  id: id || testid,
  medium: true,
  bold: true,
  margin: "20px 0",
  customStyle: {
    flex: 1
  }
}, title), link && /*#__PURE__*/React.createElement(Link, {
  to: link,
  style: {
    textDecoration: 'none'
  }
}, /*#__PURE__*/React.createElement(Text, {
  small: true,
  color: colors.skyBlue
}, "See all")));
export default Subtitle;